export default "__VITE_ASSET__34bbcff6__"